"use strict";
'use strict';

var presence = require('@ark-ui/react/presence');
var factory = require('../../styled-system/factory.cjs');

const Presence = factory.chakra(presence.Presence);

exports.Presence = Presence;
